// Number formatting utilities
export const formatNumber = (num, decimals = 2) => {
  if (num === null || num === undefined) return '—';
  const n = parseFloat(num);
  if (isNaN(n)) return '—';
  if (n >= 1e9) return (n / 1e9).toFixed(decimals) + 'B';
  if (n >= 1e6) return (n / 1e6).toFixed(decimals) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(decimals) + 'K';
  return n.toFixed(decimals);
};

export const formatCC = (num) => {
  if (num === null || num === undefined) return '—';
  const n = parseFloat(num);
  if (isNaN(n)) return '—';
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 });
};

export const formatTime = (timestamp) => {
  if (!timestamp) return '—';
  const date = new Date(timestamp);
  const diff = Date.now() - date.getTime();
  if (diff < 0) return 'just now';
  if (diff < 60000) return Math.floor(diff / 1000) + 's ago';
  if (diff < 3600000) return Math.floor(diff / 60000) + 'm ago';
  if (diff < 86400000) return Math.floor(diff / 3600000) + 'h ago';
  return Math.floor(diff / 86400000) + 'd ago';
};

export const truncateParty = (party, maxLen = 24) => {
  if (!party) return '—';
  const parts = party.split('::');
  if (parts.length === 2) {
    const prefix = parts[0];
    const suffix = parts[1];
    // For short prefixes like "DSO", show more of the hash
    if (prefix.length <= 5) {
      return `${prefix}::${suffix.slice(0, 6)}...${suffix.slice(-6)}`;
    }
    // For longer prefixes, truncate the prefix too
    const truncPrefix = prefix.length > 20 ? prefix.slice(0, 20) + '...' : prefix;
    return `${truncPrefix}::${suffix.slice(0, 4)}...${suffix.slice(-4)}`;
  }
  return party.length > maxLen ? `${party.slice(0, 12)}...${party.slice(-4)}` : party;
};

export const getMedianPrice = (votes) => {
  if (!votes || votes.length === 0) return null;
  const prices = votes.map(v => parseFloat(v.payload?.amuletPrice || 0)).filter(p => p > 0).sort((a, b) => a - b);
  if (prices.length === 0) return null;
  const mid = Math.floor(prices.length / 2);
  return prices.length % 2 !== 0 ? prices[mid] : (prices[mid - 1] + prices[mid]) / 2;
};
